import { render, staticRenderFns } from "./index-search.vue?vue&type=template&id=24b0e756&scoped=true&"
import script from "./index-search.vue?vue&type=script&lang=js&"
export * from "./index-search.vue?vue&type=script&lang=js&"
import style0 from "./index-search.vue?vue&type=style&index=0&id=24b0e756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0e756",
  null
  
)

export default component.exports